import cn from 'classnames';
import { DetailedHTMLProps, FC, InputHTMLAttributes, ReactNode } from 'react';
import IconAnimatedSpinner from '../../../assets/icons/animated-spinner.svg';
import IconCircleError from '../../../assets/icons/circle-error.svg';
import Label from '../label';
import ValidationErrors from '../validation-errors';
import { FormattedMessage, useIntl } from 'react-intl';

export interface InputProps
  extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  helper?: string | ReactNode;
  label?: ReactNode;
  labelClass?: string;
  showIcon?: boolean;
  [key: string]: any;
  name: string;
}

/**
 * @deprecated this is old version of input. You should use NewInput or FormInput instead
 */
const Input: FC<InputProps> = ({
  className,
  placeholder,
  helper,
  required,
  formState,
  register,
  label,
  labelClass,
  showIcon = true,
  name,
  ...inputProps
}) => {
  const { formatMessage } = useIntl();

  if (!formState) return null;

  const { errors, isValidating, touchedFields, isSubmitted } = formState;
  const touched = touchedFields[name];

  return (
    <div className="pb-4">
      {label && (
        <Label className={labelClass} required={required} htmlFor={name}>
          {typeof label === 'string' ? <FormattedMessage id={label} /> : <>{label}</>}
        </Label>
      )}
      <div className="relative">
        <input
          {...register(name)}
          id={name}
          data-test={`input-${name}`}
          type={inputProps.type}
          placeholder={placeholder && formatMessage({ id: placeholder })}
          className={cn(
            'border-grey-300 bg-grey-50 text-text-light-bg-secondary hover:border-grey-300 focus:border-primary-main h-12 w-full rounded-lg border px-4 py-3 text-base leading-tight hover:border-2 focus:border-2 focus:outline-hidden',
            className,
            touched && 'border-primary-main border-2',
            errors[name] &&
              isSubmitted &&
              'border-2 border-red-400 hover:border-red-400 focus:border-red-400'
          )}
        />
        {showIcon && (
          <div className="absolute top-0 right-0 bottom-0 flex h-full w-8 items-center">
            {isValidating ? (
              <IconAnimatedSpinner className="text-spinner-light h-auto w-5" />
            ) : (
              <>{errors[name] && isSubmitted && <IconCircleError className="h-auto w-4" />}</>
            )}
          </div>
        )}
      </div>
      {isSubmitted && (
        <ValidationErrors
          errors={errors[name]?.message}
          helper={helper}
          isSubmitted={isSubmitted}
        />
      )}
    </div>
  );
};

export default Input;
